// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__xTNd2","row":"Table_row__A0rdx","tableContainer":"Table_tableContainer__8qNQ0","title":"Table_title__iGGEs"};